(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-note"] && !Shopify.designMode) return;
  try {
    (function () {
    function render(note) {
      var template = note.getAttribute('data-template') || '';
      var cutoff = note.getAttribute('data-cutoff-hour');
      var textEl = note.querySelector('.shipping-note__text');
      if (!textEl) return;

      var hasCountdown = template.indexOf('[countdown]') !== -1;
      if (!hasCountdown) {
        note.hidden = false;
        textEl.textContent = template;
        return;
      }

      if (cutoff === null || cutoff === '') {
        textEl.textContent = template.replace('[countdown]', '').replace(/\s+/g, ' ').trim();
        return;
      }

      var now = new Date();
      var deadline = new Date();
      deadline.setHours(parseInt(cutoff, 10), 0, 0, 0);
      var diffMs = deadline - now;

      if (diffMs <= 0) {
        note.hidden = true;
        return;
      }

      var totalMinutes = Math.floor(diffMs / 60000);
      var hours = Math.floor(totalMinutes / 60);
      var minutes = totalMinutes % 60;
      var parts = [];
      if (hours > 0) parts.push(hours + 'h');
      parts.push(minutes + 'm');
      note.hidden = false;
      textEl.textContent = template.replace('[countdown]', parts.join(' '));
    }

    document.querySelectorAll('[data-shipping-note]').forEach(function (note) {
      render(note);
      setInterval(function () { render(note); }, 60000);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function initStickyAtc(bar) {
      // dehome's buy box uses document-unique ids, not per-section ones.
      var realBtn = document.getElementById('dh-atc');
      if (!realBtn) return;

      var priceSource = document.getElementById('dh-price');
      var stickyPrice = bar.querySelector('[data-sticky-atc-price]');
      var stickyBtn = bar.querySelector('[data-sticky-atc-button]');
      if (!stickyBtn) return;

      function syncPrice() {
        if (priceSource && stickyPrice) stickyPrice.textContent = priceSource.textContent.trim();
      }
      if (priceSource) {
        new MutationObserver(syncPrice).observe(priceSource, { childList: true, subtree: true, characterData: true });
        syncPrice();
      }

      function syncBtn() {
        stickyBtn.disabled = realBtn.hasAttribute('disabled');
        var label = realBtn.textContent.trim();
        if (label) stickyBtn.textContent = label;
      }
      new MutationObserver(syncBtn).observe(realBtn, { attributes: true, childList: true, subtree: true });
      syncBtn();

      stickyBtn.addEventListener('click', function () {
        realBtn.click();
      });

      // Show only once the real button has scrolled ABOVE the viewport, so the
      // bar never covers the button it duplicates.
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var above = entry.boundingClientRect.top < 0;
          bar.hidden = !(!entry.isIntersecting && above);
        });
      }, { threshold: 0 });
      observer.observe(realBtn);
    }

    function initAll() {
      document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
